import { Checkbox } from "antd";
import styled from "styled-components";

const LargeCheckBox = (props) => {
  const { isChecked, SetIsChecked, isSmall } = props;
  return (
    <Wrapper isSmall={isSmall} {...(props.id ? { id: props.id } : {})} data-class="checkbox-wrapper">
      <Checkbox onChange={SetIsChecked} checked={isChecked} />
    </Wrapper>
  );
};

export default LargeCheckBox;

const Wrapper = styled.div`
  .ant-checkbox-checked::after {
    background-color: #fff;
  }
  .ant-checkbox-checked .ant-checkbox-inner::after {
    border: solid 2px #27ce0a;
  }
  .ant-checkbox:hover::after,
  .ant-checkbox-wrapper:hover .ant-checkbox::after {
    visibility: hidden;
  }
  ${(props) =>
    props.isSmall
      ? `
    .ant-checkbox-inner {
      height: 15px;
      width: 15px;
      border-radius: 4px;
    }
    .ant-checkbox-inner::after {
      top: 46%;
      left: 22%;
      width: 4px;
      height: 10px;
    }
  `
      : `
    .ant-checkbox-inner {
      height: 23px;
      width: 23px;
      border-radius: 4px;
      @media all and (max-width:1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25){
        height: 16px;
        width: 16px;
        border-radius: 3px;
      }
    }
    .ant-checkbox-inner::after {
      top: 46%;
      left: 22%;
      width: 7px;
      height: 14px;
      @media all and (max-width:1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25){
        width: 5px;
        height: 10px;
      }
    }
 
  `}
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #fff !important;
    border-color: #27ce0a;
  }
  .ant-checkbox-checked .ant-checkbox-inner::after {
    border: solid 2px #27ce0a;
    border-top: 0;
    border-left: 0;
  }
`;
